import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinanceColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.53906 11C8.53906 9.89543 9.43449 9 10.5391 9H28.5391C29.6436 9 30.5391 9.89543 30.5391 11V29C30.5391 30.1046 29.6436 31 28.5391 31H10.5391C9.43449 31 8.53906 30.1046 8.53906 29V11Z",
			fill: "url(#paint0_angular_320_31601)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9688 16.5509C26.5783 16.1603 26.5783 15.5272 26.9688 15.1366C27.3593 14.7461 27.9925 14.7461 28.383 15.1366L32.4833 19.2369C32.8738 19.6274 32.8738 20.2606 32.4833 20.6511C32.0927 21.0416 31.4596 21.0416 31.069 20.6511L26.9688 16.5509Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9727 20.5538C12.5822 20.1633 12.5822 19.5301 12.9727 19.1396C13.3633 18.749 13.9964 18.749 14.3869 19.1396L19.4001 24.1527C19.7906 24.5433 19.7906 25.1764 19.4001 25.567C19.0096 25.9575 18.3764 25.9575 17.9859 25.567L12.9727 20.5538Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3673 25.5673C18.9767 25.9578 18.3436 25.9578 17.953 25.5673C17.5625 25.1768 17.5625 24.5436 17.953 24.1531L26.9639 15.1422C27.3545 14.7517 27.9876 14.7517 28.3781 15.1422C28.7687 15.5327 28.7687 16.1659 28.3781 16.5564L19.3673 25.5673Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.12117 25.8105C8.73064 26.201 8.09748 26.201 7.70696 25.8105C7.31643 25.4199 7.31643 24.7868 7.70696 24.3963L12.9603 19.1429C13.3508 18.7524 13.984 18.7524 14.3745 19.1429C14.765 19.5335 14.765 20.1666 14.3745 20.5572L9.12117 25.8105Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_angular_320_31601",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(6.53906 24) rotate(-95.3558) scale(16.0702 15.3851)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 341094e-9,
					stopColor: "#AC8EFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .170369,
					stopColor: "#757BFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .46356,
					stopColor: "#51B7D8"
				})
			]
		}) })
	]
});
export default SvgFinanceColored;
